/*-----------------------------------------------------------------
- Studio translations
-----------------------------------------------------------------*/
export default {
    other_locales: 'زبان‌های دیگر',
    edit         : 'ویرایش اطلاعات',
    view         : 'نمایش در سایت',
};
